import React from 'react'
let memoizedColumns = []
const ChartLockIssueColumn = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'chart_lock_issue',
            header: 'Chart Lock Issue',
        },
       
    ]
    return memoizedColumns
}

export default ChartLockIssueColumn